import { useState as r, useEffect as l, useCallback as n } from "react";
import { D as o } from "./libServer-MKeVPlN9.js";
function h(t) {
  const [e, i] = r(!1), s = n(() => i(!0), []), d = n(() => i(!1), []), w = n(() => i((u) => !u), []);
  return { value: e, setValue: i, setTrue: s, setFalse: d, toggle: w };
}
function f() {
  const [t, e] = r({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return l(() => {
    function i() {
      e({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", i), i(), () => window.removeEventListener("resize", i);
  }, []), t;
}
function p() {
  const { width: t } = f();
  let e = "desktop";
  return t && t <= o.MOBILE ? e = "mobile" : t && t <= o.TABLET && (e = "tablet"), {
    currentWidth: t,
    currentDevice: e,
    isMobile: e === "mobile",
    isTablet: e === "tablet",
    isDesktop: e === "desktop",
    isReady: typeof window < "u"
  };
}
export {
  h as O,
  p as V
};
